var map = {
	"./markets-brockmans.jpg": "c89c",
	"./markets-callaway.jpg": "95bf",
	"./markets-cdm.jpg": "cf71",
	"./markets-dragon-capital.jpg": "b73d",
	"./markets-emmert.jpg": "2560",
	"./markets-ferrero.jpg": "cfe6",
	"./markets-firmenich.jpg": "5ebb",
	"./markets-hsc.jpg": "80f2",
	"./markets-manifest.jpg": "7a76",
	"./markets-reckitt.jpg": "4c73"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b4c0";